/*
 * CUSTOM CODE
 * Color swatches in other languages than the store's primary language.
 *
 * The swatch files are named after the English color names (swatch-<color>.jpg). On a
 * translated page Liquid only knows the translated color name, so it cannot find them
 * (see snippets/product-variant-options.liquid, which falls back to a swatch file named
 * after the translated color, or the variant's own image).
 *
 * This script is only loaded on translated pages. It fetches the same sections in the
 * primary language and copies those swatch images in, so only the English-named swatch
 * files have to be maintained.
 */
(function () {
  const config = window.swatchLocale || {};
  const root = (config.root || '/').replace(/\/$/, '');
  if (!root || !window.location.pathname.startsWith(root)) return;

  const swatchSelector = 'img.img-no-marking';
  const sections = Array.from(document.querySelectorAll('.shopify-section'))
    .filter((section) => section.querySelector(swatchSelector) && !section.id.includes('cart-drawer'))
    .slice(0, 5); // the Section Rendering API returns at most 5 sections per request
  if (!sections.length) return;

  const ids = sections.map((section) => section.id.replace('shopify-section-', ''));
  const path = window.location.pathname.slice(root.length) || '/';

  fetch(`${path}?sections=${encodeURIComponent(ids.join(','))}`)
    .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
    .then((primary) => {
      sections.forEach((section, index) => {
        const html = primary[ids[index]];
        if (!html) return;

        const source = new DOMParser().parseFromString(html, 'text/html').querySelectorAll(swatchSelector);
        const target = section.querySelectorAll(swatchSelector);
        // The colors come in the same order in every language. If the counts differ
        // something else is going on, so the swatches are left as they are.
        if (source.length !== target.length) return;

        target.forEach((image, i) => {
          ['src', 'srcset', 'sizes', 'width', 'height'].forEach((attribute) => {
            const value = source[i].getAttribute(attribute);
            if (value === null) image.removeAttribute(attribute);
            else image.setAttribute(attribute, value);
          });
        });
      });
    })
    .catch(() => {
      // Keep the swatches Liquid rendered.
    });
})();
